/**
 * Valid benefit field names for Basic Life
 *
 * Used to filter out fields that don't belong to the Basic Life coverage type
 * when transforming benefits for saving to the backend API.
 */
export const BASIC_LIFE_VALID_FIELDS = new Set([
  "objectType",
  // Benefit Amount fields
  "benefitAmount",
  // Benefit Maximum fields
  "benefitMaximum",
  // Guarantee Issue fields
  "guaranteeIssue",
  // Definition of Earnings fields
  "definitionOfEarnings",
  // Spouse Benefit fields
  "spouseBenefit",
  // Child Benefit fields
  "childBenefit",
  // Age Reduction Schedule fields
  "ageReductionSchedule",
  // Simple fields
  "portability",
  "employerContribution",
  "conversion",
  "acceleratedDeathBenefit",
  "waiverOfPremium",
  "extended",
]);
